"use strict";
// !!! DO NOT EDIT !!! Automatically generated file
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynthsByName = void 0;
exports.SynthsByName = {
    sUSD: {
        asset: 'USD',
        category: 'forex',
        sign: '$',
        description: 'US Dollars',
        name: 'sUSD',
        subclass: 'MultiCollateralSynth',
    },
    sEUR: {
        asset: 'EUR',
        category: 'forex',
        sign: '€',
        description: 'Euros',
        name: 'sEUR',
        subclass: 'MultiCollateralSynth',
    },
    sJPY: {
        asset: 'JPY',
        category: 'forex',
        sign: '¥',
        description: 'Japanese Yen',
        name: 'sJPY',
        subclass: 'MultiCollateralSynth',
    },
    sAUD: {
        asset: 'AUD',
        category: 'forex',
        sign: '$',
        description: 'Australian Dollars',
        name: 'sAUD',
        subclass: 'MultiCollateralSynth',
    },
    sGBP: {
        asset: 'GBP',
        category: 'forex',
        sign: '£',
        description: 'Pound Sterling',
        name: 'sGBP',
        subclass: 'MultiCollateralSynth',
    },
    sCHF: {
        asset: 'CHF',
        category: 'forex',
        sign: 'Fr',
        description: 'Swiss Franc',
        name: 'sCHF',
        subclass: 'MultiCollateralSynth',
    },
    sKRW: {
        asset: 'KRW',
        category: 'forex',
        sign: '₩',
        description: 'South Korean Won',
        name: 'sKRW',
        subclass: 'MultiCollateralSynth',
    },
    sBTC: {
        asset: 'BTC',
        category: 'crypto',
        sign: '₿',
        description: 'Bitcoin',
        name: 'sBTC',
        subclass: 'MultiCollateralSynth',
    },
    sETH: {
        asset: 'ETH',
        category: 'crypto',
        sign: 'Ξ',
        description: 'Ether',
        name: 'sETH',
        subclass: 'MultiCollateralSynth',
    },
    sLINK: {
        asset: 'LINK',
        category: 'crypto',
        sign: '',
        description: 'Chainlink',
        name: 'sLINK',
        subclass: 'MultiCollateralSynth',
    },
    sADA: {
        asset: 'ADA',
        category: 'crypto',
        sign: '',
        description: 'Cardano',
        name: 'sADA',
        subclass: 'MultiCollateralSynth',
    },
    sAAVE: {
        asset: 'AAVE',
        category: 'crypto',
        sign: '',
        description: 'Aave',
        name: 'sAAVE',
        subclass: 'MultiCollateralSynth',
    },
    sDOT: {
        asset: 'DOT',
        category: 'crypto',
        sign: '',
        description: 'Polkadot',
        name: 'sDOT',
        subclass: 'MultiCollateralSynth',
    },
    sETHBTC: {
        asset: 'ETHBTC',
        category: 'crypto',
        sign: '',
        description: 'ETH / BTC',
        name: 'sETHBTC',
        subclass: 'MultiCollateralSynth',
    },
};
